import { dmApi } from "../../app/dmApi";
import { serialize } from "../../helpers/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";

export const employeeAttendanceApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getEmployeeAttendanceList: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/attendance?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['employeeAttendance'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getEmployeeAttendanceSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/attendance/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['employeeAttendanceSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        markEmployeeAttendance: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/attendance/mark`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['employeeAttendance', 'employeeAttendanceSummary', 'employeeAttendanceReport'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Attendance")
            },
        }),
        getEmployeeAttendanceReportList: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/attendance/report?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['employeeAttendanceReport'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    })
});

export const {
    useGetEmployeeAttendanceListQuery,
    useGetEmployeeAttendanceSummaryQuery,
    useMarkEmployeeAttendanceMutation,
    useGetEmployeeAttendanceReportListQuery,
} = employeeAttendanceApi;